// extracted by mini-css-extract-plugin
module.exports = {"iconQrCode":"styles_iconQrCode__2Qsrr"};